import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'
import { DashboardTypes } from 'features/Codes'
import { createSlice } from '@reduxjs/toolkit'

const DeleteAPIs = {
  [DashboardTypes.CAMPAIGN]: api.dashboard.deleteCampaigns,
  [DashboardTypes.AD_GROUP]: api.dashboard.deleteAdGroups,
  [DashboardTypes.KEYWORD]: api.dashboard.deleteKeywords,
  [DashboardTypes.CREATIVE]: api.dashboard.deleteCreativeLinks,
}

export const deleteDashboardItems = createAxiosThunk(
  'dashboard/deleteDashboardItems',
  ({ type, ids }) => DeleteAPIs[type]({ ids })
)

const dashboardDeleteSlice = createSlice({
  name: 'dashboard/operation/delete',

  initialState: {
    isSubmitting: false,
  },

  extraReducers: builder => {
    builder.addCase(deleteDashboardItems.pending, state => {
      state.isSubmitting = true
    })

    builder.addCase(deleteDashboardItems.rejected, state => {
      state.isSubmitting = false
    })

    builder.addCase(deleteDashboardItems.fulfilled, state => {
      state.isSubmitting = false
    })
  },
})

export default dashboardDeleteSlice.reducer
